import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Bundle translations directly — guarantees all namespaces are available
// synchronously before React renders. Critical for prerender to capture
// translated text instead of raw i18n keys (~91 KB total, ~18 KB gzipped).
import esTranslation from '../public/locales/es/translation.json';
import esNav from '../public/locales/es/nav.json';
import esSeo from '../public/locales/es/seo.json';

import enTranslation from '../public/locales/en/translation.json';
import enNav from '../public/locales/en/nav.json';
import enSeo from '../public/locales/en/seo.json';

import frTranslation from '../public/locales/fr/translation.json';
import frNav from '../public/locales/fr/nav.json';
import frSeo from '../public/locales/fr/seo.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: esTranslation, nav: esNav, seo: esSeo },
      en: { translation: enTranslation, nav: enNav, seo: enSeo },
      fr: { translation: frTranslation, nav: frNav, seo: frSeo },
    },
    supportedLngs: ['es', 'en', 'fr'],
    fallbackLng: 'es',
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
      lookupLocalStorage: 'fm_lang',
    },
    ns: ['translation', 'nav', 'seo'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
